import loadable from '@loadable/component'
import React from 'react'
import { FeatureToggle } from 'component-library/feature-toggling/Toggle/Toggle'
import { TheWestLivePlayerPageProps } from './TheWestLivePlayerPage'

const LazyTheWestLivePlayerComponent = loadable(() =>
    import('component-library/content/TheWestLive/TheWestLivePlayerPage/TheWestLivePlayerPage')
)

// Standalone lazy load component
export const LazyTheWestLivePlayerPage = (props: TheWestLivePlayerPageProps) => {
    return (
        <FeatureToggle
            feature="the-west-live"
            on={() => <LazyTheWestLivePlayerComponent {...props} />}
        />
    )
}
